import { create } from 'zustand';

export const useMapStore = create((set) => ({
  selectedLayer: 'ops', // 'ops' | 'liderazgo' | 'near_misses'
  showCluster: true,
  showHeatmap: false,
  selectedCentro: null,
  arcgisToken: null,
  tokenExpiry: null,

  setSelectedLayer: (layer) => set({ selectedLayer: layer }),
  toggleCluster: () => set((s) => ({ showCluster: !s.showCluster })),
  toggleHeatmap: () => set((s) => ({ showHeatmap: !s.showHeatmap })),
  setSelectedCentro: (centro) => set({ selectedCentro: centro }),
  setArcgisToken: (token, expiry) => set({ arcgisToken: token, tokenExpiry: expiry }),
}));
